import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { AgentCategorySearchDto } from '../../agent-categories';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { AgentStatusEnum } from '../enums/agent-status.enum';
import { AgentTypeEnum } from '../enums/agent-type.enum';

/**
 * Agent DTO for records
 */
@CaslSubject(AppSubjectEnum.AGENT)
export class AgentRecordDto extends BaseDto {
  uuid!: string;
  code!: string;
  status!: AgentStatusEnum;
  type!: AgentTypeEnum;
  notes?: string | null;
  contact!: TenantContactDto;
  agentCategoryId?: number | null;
  agentCategory?: AgentCategorySearchDto | null;
  tags?: TagListDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
